import { Link } from 'react-router-dom'
import { Box, Button, Card, CardContent, Typography, useTheme } from '@mui/material'
import { useAuth } from 'src/contexts/AuthContext'
import { isTeamFeatureEnabled } from 'src/utils/featureFlags'
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline'
import ReceiptIcon from '@mui/icons-material/Receipt'
import CardMembershipIcon from '@mui/icons-material/CardMembership'

export function DashboardPage() {
  const { user } = useAuth()
  const theme = useTheme()

  return (
    <>
      <Typography variant="h4" sx={{ fontWeight: 700, color: '#2c3e50', mb: 0.5 }}>
        Tableau de bord
      </Typography>
      <Typography variant="body1" sx={{ color: '#7f8c8d', mb: 4 }}>
        Bienvenue, {user?.email ?? 'utilisateur'}.
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr' },
          gap: 3,
          alignItems: 'stretch'
        }}>
        <Card
          sx={{
            borderRadius: 3,
            border: '1px solid rgba(0,0,0,0.06)',
            boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
            transition: 'all 0.25s ease',
            height: '100%',
            '&:hover': { boxShadow: '0 8px 24px rgba(66,119,185,0.12)', transform: 'translateY(-2px)' }
          }}>
          <CardContent sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
              <CardMembershipIcon sx={{ color: theme.palette.primary.main, fontSize: 28 }} />
              <Typography variant="h6" sx={{ fontWeight: 600, color: '#2c3e50' }}>
                Abonnement
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: '#7f8c8d', mb: 3, lineHeight: 1.6 }}>
              Souscrivez un abonnement pour votre équipe. Les tarifs sont affichés clairement.
            </Typography>
            <Box sx={{ mt: 'auto' }}>
              <Button
                component={Link}
                to="/subscription"
                variant="contained"
                sx={{
                  borderRadius: 2,
                  fontWeight: 600,
                  textTransform: 'none',
                  px: 3,
                  background: 'linear-gradient(135deg, #4277b9 0%, #2c5aa0 100%)',
                  '&:hover': { background: 'linear-gradient(135deg, #2c5aa0 0%, #1e3a6b 100%)' }
                }}>
                Voir les offres
              </Button>
            </Box>
          </CardContent>
        </Card>

        {isTeamFeatureEnabled() && (
          <Card
            sx={{
              borderRadius: 3,
              border: '1px solid rgba(0,0,0,0.06)',
              boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
              transition: 'all 0.25s ease',
              height: '100%',
              '&:hover': { boxShadow: '0 8px 24px rgba(66,119,185,0.12)', transform: 'translateY(-2px)' }
            }}>
            <CardContent sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                <PeopleOutlineIcon sx={{ color: theme.palette.primary.main, fontSize: 28 }} />
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#2c3e50' }}>
                  Mon équipe
                </Typography>
              </Box>
              <Typography variant="body2" sx={{ color: '#7f8c8d', mb: 3, lineHeight: 1.6 }}>
                Gérez les abonnements de vos collaborateurs, ajoutez des membres et suivez l&apos;état de votre groupe.
              </Typography>
              <Box sx={{ mt: 'auto' }}>
                <Button
                  component={Link}
                  to="/team"
                  variant="outlined"
                  sx={{
                    borderRadius: 2,
                    fontWeight: 600,
                    textTransform: 'none',
                    px: 3,
                    borderWidth: 2,
                    borderColor: theme.palette.primary.main,
                    color: theme.palette.primary.main,
                    '&:hover': {
                      borderWidth: 2,
                      borderColor: theme.palette.primary.dark,
                      backgroundColor: 'rgba(66,119,185,0.06)'
                    }
                  }}>
                  Voir mon équipe
                </Button>
              </Box>
            </CardContent>
          </Card>
        )}

        <Card
          sx={{
            borderRadius: 3,
            border: '1px solid rgba(0,0,0,0.06)',
            boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
            transition: 'all 0.25s ease',
            height: '100%',
            '&:hover': { boxShadow: '0 8px 24px rgba(66,119,185,0.12)', transform: 'translateY(-2px)' }
          }}>
          <CardContent sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
              <ReceiptIcon sx={{ color: theme.palette.primary.main, fontSize: 28 }} />
              <Typography variant="h6" sx={{ fontWeight: 600, color: '#2c3e50' }}>
                Mes factures
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: '#7f8c8d', mb: 3, lineHeight: 1.6 }}>
              Consultez et téléchargez vos factures d&apos;abonnement.
            </Typography>
            <Box sx={{ mt: 'auto' }}>
              <Button
                component={Link}
                to="/bills"
                variant="outlined"
                sx={{
                  borderRadius: 2,
                  fontWeight: 600,
                  textTransform: 'none',
                  px: 3,
                  borderWidth: 2,
                  borderColor: theme.palette.primary.main,
                  color: theme.palette.primary.main,
                  '&:hover': {
                    borderWidth: 2,
                    borderColor: theme.palette.primary.dark,
                    backgroundColor: 'rgba(66,119,185,0.06)'
                  }
                }}>
                Voir les factures
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </>
  )
}
